export class MenuEditor {
    static mount(container, options = {}) {
        const {
            initialValue = '',
            readOnly = false,
            onChange = () => {},
            onReady = () => {},
            onValidationChange = () => {},
            language = 'json',
        } = options;

        const handle = {
            _editor: null,
            _fallback: false,
            getEditor() { return this._editor; },
            getValue() {
                const e = this._editor;
                return e ? (typeof e.getValue === 'function' ? e.getValue() : initialValue) : initialValue;
            },
            setValue(v) {
                const e = this._editor;
                if (e && typeof e.setValue === 'function') {
                    const cur = typeof e.getValue === 'function' ? e.getValue() : null;
                    if (cur !== v) e.setValue(v);
                }
            },
            dispose() {
                try {
                    const e = this._editor;
                    if (e && typeof e.dispose === 'function') e.dispose();
                } catch (err) {
                    console.error('MenuEditor dispose failed', err);
                }
                this._editor = null;
            },
        };

        let attempts = 0;
        const maxAttempts = 20;

        const tryMount = () => {
            if (window.monaco) {
                const editor = window.monaco.editor.create(container, {
                    value: initialValue,
                    language,
                    wordWrap: 'on',
                    automaticLayout: true,
                    readOnly,
                    scrollbar: { alwaysConsumeMouseWheel: false },
                    minimap: { enabled: false },
                });
                handle._editor = editor;

                editor.onDidChangeModelContent(() => {
                    onChange(editor.getValue());
                    MenuEditor._checkValidation(editor, onValidationChange);
                });

                const model = editor.getModel();
                if (model) {
                    window.monaco.editor.onDidChangeMarkers((uris) => {
                        if (uris.some((uri) => uri.toString() === model.uri.toString())) {
                            MenuEditor._checkValidation(editor, onValidationChange);
                        }
                    });
                }
                MenuEditor._checkValidation(editor, onValidationChange);
                onReady(editor);
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(tryMount, 200);
            } else {
                console.warn('MenuEditor: Monaco unavailable, falling back to textarea');
                handle._fallback = true;
                container.innerHTML = '';
                const ta = document.createElement('textarea');
                ta.value = initialValue;
                ta.style.cssText = 'width:100%;height:100%;resize:none;font-family:monospace;font-size:13px;padding:8px;box-sizing:border-box;';
                ta.addEventListener('input', () => {
                    onChange(ta.value);
                    try { JSON.parse(ta.value); onValidationChange(true); } catch (e) { onValidationChange(false); }
                });
                container.appendChild(ta);
                handle._editor = {
                    getValue: () => ta.value,
                    setValue: (v) => { if (ta.value !== v) ta.value = v; },
                    dispose: () => { container.innerHTML = ''; },
                };
                onValidationChange(true);
                onReady(handle._editor);
            }
        };

        tryMount();
        return handle;
    }

    static _checkValidation(editor, onValidationChange) {
        try {
            const model = editor.getModel();
            if (!model || !window.monaco) { onValidationChange(true); return; }
            const markers = window.monaco.editor.getModelMarkers({ resource: model.uri });
            const hasErrors = markers.some((m) => m.severity === window.monaco.MarkerSeverity.Error);
            onValidationChange(!hasErrors);
        } catch (e) {
            onValidationChange(true);
        }
    }
}
